export const getVisibilityStyle = (isVisible: boolean) => {
	return {
		display: isVisible ? 'block' : 'none',
	};
};
